
        import 'CaptureForm.da4066c.css-module'
        export default {"CaptureForm":"CaptureForm_CaptureForm_da4066c"}
    